import { ConfigurationPossibleAssayResultResponse } from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.dto'

export interface ConfigurationLocalAssaysResultsModalState {
    possibleAssayResult: Partial<ConfigurationPossibleAssayResultResponse>
}
export const initialConfigurationLocalAssaysResultsModalState =
    (): ConfigurationLocalAssaysResultsModalState => ({
        possibleAssayResult: {
            active: true,
            nameTranslations: []
        }
    })
